module.exports = __webpack_public_path__ + "media/images/country_flags/za-1eca44bab0b262fb68cf63f8cb9cebaf.png";